let prod = false
let prodincloud = true
export default {
  server: prodincloud ? 'https://fsamtaapi.gootwork.com/api/v1/' : prod ? '/api/v1/':'http://localhost:3000/api/v1/',
  serverweb: prodincloud ? 'https://fsamtaapi.gootwork.com/' : prod ? 'http://localhost:3000/':'http://localhost:3000/',
  host: prodincloud ? 'https://'+document.domain+'/' : prod ? 'http://localhost:3000/':'http://localhost:8080/'
}
